// extracted by mini-css-extract-plugin
module.exports = {"profileCard":"style-module__profileCard___qlz4E","programName":"style-module__programName___3Q-17","attachmentIcon":"style-module__attachmentIcon___YAZFA"};